import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = false;

const isOriginalEvaluacionEditedStateSlice = createSlice({
	name: 'isOriginalEvaluacionEditedState',
	initialState,
	reducers: {
		setisOriginalEvaluacionEditedState: (state, action: PayloadAction<boolean>) => {
			return action.payload;
		},
		resetisOriginalEvaluacionEditedState: () => {
			return initialState;
		}
	}
});

export const { setisOriginalEvaluacionEditedState, resetisOriginalEvaluacionEditedState } =
	isOriginalEvaluacionEditedStateSlice.actions;

export default isOriginalEvaluacionEditedStateSlice.reducer;
